import React from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { clearFilters } from '@/redux/slices/dataTableSlice';
import { Breadcrumbs, TitleBar } from '@/components/_common';
import { Grid } from '@mui/material';
import { dataTableInitialState } from '@/redux/selectors/configSelectors';
import { DataTableConfig } from '@/__configs/config_types';
import { IngestFile } from '@/redux/slices/slice_types';

type FileIngestTitleBarProps = {
  data: IngestFile;
};

const FileIngestTitleBar = ({ data }: FileIngestTitleBarProps) => {
  const dispatch = useAppDispatch();
  const tableName = useAppSelector(selectCurrentTableKey);
  const title = dataTableInitialState[tableName as keyof DataTableConfig]?.title;

  const onBreadcrumbClick = () => {
    dispatch(clearFilters());
  };

  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ minHeight: 30 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/ingest-management" onClick={onBreadcrumbClick}>
            {title || 'Ingest Manager'}
          </Link>
          <span>Ingest Record #{data.hid}</span>
        </Breadcrumbs>
      </Grid>
    </TitleBar>
  );
};

export default FileIngestTitleBar;
